import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"icon-close\"><path d=\"M5.355 6.055L.7 1.4a.495.495 0 11.7-.7l4.655 4.655L10.71.7a.495.495 0 01.7.7L6.755 6.055l4.655 4.655a.495.495 0 01-.7.7L6.055 6.755 1.4 11.41a.495.495 0 01-.7-.7l4.655-4.655z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol